import { getNewsApi } from 'api/article'
import errorHandler from 'utils/errorHandler'

export default payload => async (dispatch) => {
  try {
    return await getNewsApi(payload)
  } catch (error) {
    return errorHandler(error)
  }
}
